import { useEffect, useRef } from "react";

import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";

import FnrSlides from "UI/FnrSlides";

import { useActiveComponentKey } from "../../stateHooks";
import HelpMessage from "../HelpMessage";

import { useComponentsConfig } from "./componentsConfig";

const ComponentSwitch = () => {
  const activeComponentKey = useActiveComponentKey();
  const componentsConfig = useComponentsConfig();
  const { variant, onStepChange } = useTwoFAContext();
  const { isInitialLoading } = usePostTwoFactorAuth({ variant });
  const prevKeyRef = useRef(activeComponentKey);

  useEffect(() => {
    if (onStepChange && activeComponentKey !== prevKeyRef.current) {
      onStepChange(activeComponentKey);
      prevKeyRef.current = activeComponentKey;
    }
  }, [activeComponentKey, onStepChange]);

  if (isInitialLoading) return null;
  return (
    <div>
      <FnrSlides
        components={componentsConfig}
        activeKey={activeComponentKey}
        fullWidth
        clip={false}
      />
      <HelpMessage />
    </div>
  );
};

export default ComponentSwitch;
